import { ProgressPie } from "@spz/ui/components/progress";
import { cn } from "@spz/ui/lib/utils";
import type { ProgressCellProps } from "../types";

export const ProgressCell: React.FC<ProgressCellProps> = ({
  value,
  showLabel = true,
  variant,
  colorClassName,
  className,
}) => {
  return (
    <div className={cn("flex justify-center items-center", className)}>
      <ProgressPie
        value={value}
        variant={variant}
        showLabel={showLabel}
        colorClassName={colorClassName}
      />
    </div>
  );
};
